import * as Sentry from '@sentry/browser';
import Vue from 'vue';

const isProduction = process.env.VUE_APP_ENV === 'production';

Sentry.init({
  dsn: 'https://4a82f523f6064f0c9d573c64cc570646@sentry.io/1402127',
  integrations: isProduction
    ? [new Sentry.Integrations.Vue({ Vue, attachProps: true })]
    : [],
  beforeSend(event) {
    return isProduction ? event : null;
  },
});
